"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config = {
    stage: "prod",
    dataStage: "prod",
    apiGateway: {
        url: "https://api.photomaps.com",
    },
    contentUrl: "https://content.photomaps.com",
    userContentUrl: "https://user-content-direct-prod.photomaps.com",
    userContentImageServerUrl: "https://user-content-prod.photomaps.com",
    staticUrl: "https://static-prod.photomaps.com",
    imageServerBucket: "mapmaker-user-content-prod",
    internalBucket: "mapmaker-internal-prod",
    walgreens: {
        production: true,
        apiKey: "DyvrlukqmWDQQW3XKGmqVKtHl6YFHejX",
        affiliateId: "THUNDRBUNY",
        publisherId: "8972131",
    },
};
exports.default = config;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWFwbWFrZXJDb25maWcucHJvZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9NYXBtYWtlckNvbmZpZy5wcm9kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsTUFBTSxNQUFNLEdBQW1CO0lBQzdCLEtBQUssRUFBRSxNQUFNO0lBQ2IsU0FBUyxFQUFFLE1BQU07SUFDakIsVUFBVSxFQUFFO1FBQ1YsR0FBRyxFQUFFLDJCQUEyQjtLQUNqQztJQUNELFVBQVUsRUFBRSwrQkFBK0I7SUFDM0MsY0FBYyxFQUFFLGdEQUFnRDtJQUNoRSx5QkFBeUIsRUFBRSx5Q0FBeUM7SUFDcEUsU0FBUyxFQUFFLG1DQUFtQztJQUM5QyxpQkFBaUIsRUFBRSw0QkFBNEI7SUFDL0MsY0FBYyxFQUFFLHdCQUF3QjtJQUN4QyxTQUFTLEVBQUU7UUFDVCxVQUFVLEVBQUUsSUFBSTtRQUNoQixNQUFNLEVBQUUsa0NBQWtDO1FBQzFDLFdBQVcsRUFBRSxZQUFZO1FBQ3pCLFdBQVcsRUFBRSxTQUFTO0tBQ3ZCO0NBQ0YsQ0FBQztBQUNGLGtCQUFlLE1BQU0sQ0FBQyJ9